/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import React, { useState, useContext } from 'react';
import validate from 'validate.js'
import { IndexContext } from '../IndexProvider';

const oneTimePasswordConstraints = {
    oneTimePassword: {
        presence: true,
        format: {
            pattern: /^[0-9]{6}$/,
        }
    }
};

export default function TotpConfirm() {
    const [oneTimePassword, setOneTimePassword] = useState("")
    const [shouldShowFeedback, setShouldShowFeedback] = useState(false)
    const [isOneTimePasswordValid, setIsOneTimePasswordValid] = useState(false)
    const [isPending, setIsPending] = useState(false)

    const { loginWithTotp, loginDetails } = useContext(IndexContext)

    const onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (validate({ oneTimePassword: oneTimePassword }, oneTimePasswordConstraints)) {
            setIsOneTimePasswordValid(false)
        } else {
            setIsOneTimePasswordValid(true)
            setIsPending(true)
            await loginWithTotp(loginDetails.username, loginDetails.password, oneTimePassword)
            setIsPending(false)
        }
    };

    const buildFormControlClasses = (shouldShowFeedback, isValid) => {
        if (shouldShowFeedback) {
            return `form-control ${isValid ? "is-valid" : "is-invalid"}`
        } else {
            return "form-control"
        }
    }

    const onOneTimePasswordChange = (event) => {
        setOneTimePassword(event.target.value)
        setShouldShowFeedback(true)

        if (validate({ oneTimePassword: event.target.value }, oneTimePasswordConstraints)) {
            setIsOneTimePasswordValid(false)
        } else {
            setIsOneTimePasswordValid(true)
        }
    }

    return (
        <div className="d-flex justify-content-center align-items-center ps-3 pe-3 pt-5 pb-5">
            <form noValidate className="w-100 form-container p-3" style={{ border: "1px solid #0073e6" }} onSubmit={onSubmit} >
                <div className="mb-3">
                    <label htmlFor="oneTimePassword">ワンタイムパスワード</label>
                    <input className={buildFormControlClasses(shouldShowFeedback, isOneTimePasswordValid)} onChange={onOneTimePasswordChange} value={oneTimePassword} type="email" id="oneTimePassword" required />
                    <div className="invalid-feedback">
                        有効なワンタイムパスワードを入力してください。
                    </div>
                </div>
                <button className="btn btn-primary" type="submit">
                    {isPending ? "確認中..." : "確認"}
                </button>
            </form>
        </div>
    );
}